export const chartFontFamily = "'Google Sans Flex', 'Tajawal-Medium', sans-serif"
